import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

interface ConfirmDialogProps {
  isOpen: boolean;
  title?: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  loading?: boolean;
  /** 'nested' — диалог поверх окна сущности (иначе окно закроет его собой). */
  layer?: 'default' | 'nested';
  onConfirm: () => void;
  onClose: () => void;
}

/** Диалог подтверждения в стиле дизайн-системы (замена window.confirm). */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title = 'Подтвердите действие',
  message,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  danger = false,
  loading = false,
  layer,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      layer={layer}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>{cancelLabel}</Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {/* whitespace-pre-line: длинные подтверждения (например приёмка макета)
          разбиты на абзацы переводами строк — иначе они слипались в стену. */}
      <div className="whitespace-pre-line text-sm text-gray-700 dark:text-zinc-200">{message}</div>
    </Modal>
  );
};

export default ConfirmDialog;
